import * as Sentry from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import createEmotionCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { posthog } from "posthog-js";

Sentry.init({
  environment: getEnvironment(),
  dsn: "https://422e3980d7e48286dbb8000f788c3e01@o1306653.ingest.us.sentry.io/4507093443608576",
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    // eslint-disable-next-line import/namespace
    Sentry.replayIntegration(),
    // eslint-disable-next-line import/namespace
    new Sentry.BrowserProfilingIntegration(),
  ],
});

function getEnvironment() {
  if (location.hostname === "yoyo-dev-staging.fly.dev") {
    return "staging";
  } else if (location.hostname === "yoyo-dev.fly.dev") {
    return "prod";
  }

  return "dev";
}

function PosthogInit() {
  useEffect(() => {
    if (getEnvironment() === "prod") {
      posthog.init("phc_D4YlQa360HmwXtD5LUS8Qpukd3v3lznauukf7qJZJhf", {
        api_host: "https://eu.i.posthog.com",
        autocapture: true,
      });
    }
  }, []);

  return null;
}

startTransition(() => {
  const emotionCache = createEmotionCache({ key: "css" });

  hydrateRoot(
    document,
    <StrictMode>
      <CacheProvider value={emotionCache}>
        <RemixBrowser />
        <PosthogInit />
      </CacheProvider>
    </StrictMode>
  );
});
